import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function About() {
  const benefits = ['Industry-leading conversion rates', 'Data-driven strategies and insights', 'Transparent reporting and communication', 'Customized approach for your business', 'Continuous optimization and improvement', 'Experienced team of lead generation experts'];
  return <section id="about" className="py-28 bg-gray-50 relative overflow-hidden" data-id="element-9">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-amber-100 rounded-full opacity-20 blur-3xl -z-10" data-id="element-10"></div>
      <div className="absolute bottom-0 left-0 w-1/4 h-1/4 bg-red-100 rounded-full opacity-20 blur-3xl -z-10" data-id="element-11"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-13">
          <div className="order-2 lg:order-1 relative" data-id="element-14">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl" data-id="element-15">
              <img src="https://images.unsplash.com/photo-1556761175-4b46a572b786?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1974&q=80" alt="Team meeting" className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" data-id="element-16" />
            </div>
            <div className="absolute -bottom-8 -right-8 bg-gradient-to-r from-amber-400 to-red-400 rounded-2xl shadow-xl p-6 w-64 z-20 transform transition-transform hover:scale-105 duration-300" data-id="element-17">
              <div className="text-white font-bold text-4xl" data-id="element-18">500+</div>
              <div className="text-amber-50 font-medium" data-id="element-19">Satisfied Clients</div>
            </div>
            <div className="absolute top-1/2 -left-8 transform -translate-y-1/2 bg-white rounded-2xl shadow-xl p-4 z-20" data-id="element-20">
              <div className="flex items-center space-x-2" data-id="element-21">
                <div className="flex -space-x-2" data-id="element-22">
                  {[1, 2, 3].map(i => <img key={i} className="inline-block h-8 w-8 rounded-full ring-2 ring-white" src={`https://randomuser.me/api/portraits/women/${10 + i}.jpg`} alt="" data-id="element-23" />)}
                </div>
                <div className="text-amber-600 font-semibold text-sm" data-id="element-24">
                  Team of experts
                </div>
              </div>
            </div>
          </div>
          <div className="order-1 lg:order-2" data-id="element-25">
            <div className="inline-block px-3 py-1 text-xs font-semibold text-amber-600 bg-amber-100 rounded-full mb-4" data-id="element-26">
              About Us
            </div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6" data-id="element-27">
              Your Growth Partner for Sustainable Business Success
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-28">
              Founded in 2015, Otterreach has helped over 500 businesses across
              industries transform their lead generation and sales processes.
              Our team of experts combines industry knowledge, data analytics,
              and creative strategies to deliver exceptional results.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-29">
              We don't just generate leads – we generate the right leads that
              convert into loyal customers and drive sustainable growth for your
              business.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4 mb-10" data-id="element-30">
              {benefits.map((benefit, index) => <div key={index} className="flex items-start" data-id="element-31">
                  <CheckCircleIcon className="h-6 w-6 text-amber-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-32" />
                  <span className="text-gray-700 font-medium" data-id="element-33">{benefit}</span>
                </div>)}
            </div>
            <div data-id="element-34">
              <a href="#contact" className="inline-flex items-center px-8 py-4 border border-transparent text-lg font-medium rounded-lg shadow-lg text-white bg-gradient-to-r from-amber-400 to-red-400 hover:from-amber-500 hover:to-red-500 transition-all duration-300 hover:shadow-amber-500/20" data-id="element-35">
                Work With Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}